// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"2a7147de","298":"d5c958f2","453":"99f00745","535":"121a0f11","719":"3ed64405","727":"a47374fc","741":"e2425927","766":"1d87690c","823":"2b169763","913":"5716a63b","920":"d3214528"}[chunkId] + ".chunk.js";
};